const styles = {

  colors: {
    brandPrimary: '#748e2b',
    brandSecondary: '#EAEEDF',
    brandLight: '#F8FAF5',
    gray: '#D9D9D9',
    grayOpacity: '#D9D9D980',
    lightGray: '#F4F4F4',
    darkGray: '#747474',
    white: '#FFFFFF',
    black: '#000000',
  },

  borderRadius: '3px',

  pageText: {
    fontSize: '16px',
    lineHeight: '19px',
    fontWeight: 400,
  },
  ticketPrio: {
    normal: '#989898',
    urgent: '#FFCC00',
    critical: '#D60000',
  },
  ticketStatus: {
    normal: '#989898',
    frozen: '#8B5600', // долговисящая
    overdue: ' #D60000',
    completed: ' #DCDCDC',
  },
  ticketState: {
    free: '#989898',
    work: '#005BCB',
    abandoned: '#D60000', // Как она получается ?
    close: '#DCDCDC', // приходит  в данных
  },
}

export default styles
